import { useTranslation } from '@flecto/translations'

import { IBookingStatus } from '../modules/Create/model/bookingStatus'

export const BadgeVariant = (status: IBookingStatus | null) => {
  let variant = 'brand'
  let label = ''
  const { t } = useTranslation('saas', { keyPrefix: 'booking' })

  switch (status) {
    case IBookingStatus.draft:
      variant = 'gray'
      label = t('status.draft')
      break
    case IBookingStatus.negotiation:
      variant = 'violet'
      label = t('status.negotiation')
      break
    case IBookingStatus.reserved:
      variant = 'blue'
      label = t('status.reserved')
      break
    case IBookingStatus.canceled:
      variant = 'red'
      label = t('status.canceled')
      break
    case IBookingStatus.ongoing:
      variant = 'orange'
      label = t('status.ongoing')
      break
    case IBookingStatus.completed:
      variant = 'brand'
      label = t('status.completed')
      break
    default:
      break
  }

  return {
    get variant() {
      return variant
    },
    get label() {
      return label
    },
  }
}

export const getBadgeVariant = (status: IBookingStatus | null) => {
  let variant = 'primary'
  let translationKey = ''

  switch (status) {
    case IBookingStatus.draft:
      variant = 'gray'
      translationKey = 'status.draft'
      break
    case IBookingStatus.negotiation:
      variant = 'violet'
      translationKey = 'status.negotiation'
      break
    case IBookingStatus.reserved:
      variant = 'blue'
      translationKey = 'status.reserved'
      break
    case IBookingStatus.canceled:
      variant = 'red'
      translationKey = 'status.canceled'
      break
    case IBookingStatus.ongoing:
      variant = 'orange'
      translationKey = 'status.ongoing'
      break
    case IBookingStatus.completed:
      variant = 'brand'
      translationKey = 'status.completed'
      break
    default:
      break
  }

  return {
    variant,
    translationKey,
  }
}

export const getBadgeStatusInfo = (status: IBookingStatus | null) => {
  let color = 'gray'
  let translationKey = ''

  switch (status) {
    case IBookingStatus.draft:
      color = 'gray'
      translationKey = 'status.draft'
      break
    case IBookingStatus.negotiation:
      color = 'violet'
      translationKey = 'status.negotiation'
      break
    case IBookingStatus.reserved:
      color = 'blue'
      translationKey = 'status.reserved'
      break
    case IBookingStatus.canceled:
      color = 'red'
      translationKey = 'status.canceled'
      break
    case IBookingStatus.ongoing:
      color = 'orange'
      translationKey = 'status.ongoing'
      break
    case IBookingStatus.completed:
      color = 'green'
      translationKey = 'status.completed'
      break
    default:
      break
  }

  return {
    color,
    translationKey,
  }
}

export function getBadgePaymentInfo(status: string) {
  let color = 'gray'
  let translationKey = ''

  switch (status) {
    case 'payment_rental_paid':
      color = 'green'
      translationKey = 'rental_status.payment_rental_paid'
      break
    case 'payment_rental_unpaid':
      color = 'red'
      translationKey = 'rental_status.payment_rental_unpaid'
      break
    case 'payment_rental_overpaid':
      color = 'red'
      translationKey = 'rental_status.payment_rental_overpaid'
      break
    case 'payment_rental_partially_paid':
      color = 'orange'
      translationKey = 'rental_status.payment_rental_partially_paid'
      break
    default:
      break
  }

  return {
    color,
    translationKey,
  }
}
